const tableHeaderData = [
  {
    label: "E-Id",
    type: "workerId",
    place: "left",
    toolTipText: "Click for Id Sorting"
  },
  {
    label: "Full Name",
    type: "workerFullName",
    place: "left",
    toolTipText: "Click for Name Sorting"
  },
  {
    label: "Leave Type",
    place: "left",
    type: "leaveType",
    toolTipText: "Click for Type Sorting"
  },
  {
    label: "Reason",
    place: "left",
    type: "leaveReason",
    toolTipText: "Reason of Leave"
  },
  {
    label: "From ( Date )",
    place: "left",
    type: "leaveFrom",
    toolTipText: "From Date"
  },
  {
    label: "To ( Date )",
    place: "left",
    type: "leaveTo",
    toolTipText: "To Date"
  },
  {
    label: "Days",
    place: "left",
    type: "numberOfDays",
    toolTipText: "Click for amount sorting"
  },
  {
    label: "Created At",
    place: "left",
    type: "createdAt",
    toolTipText: "Click for Date Sorting"
  }
];

const toolTipData = [
  {
    id: "date",
    text: "Select Date."
  },
  {
    id: "locationName",
    text: "Select Location to Get the Users Leave."
  },
  {
    id: "Filter",
    text: "Search by User-id,  Full Name."
  },
  {
    id: "month",
    text: "Select month."
  },
  {
    id: "year",
    text: "Select Year."
  },
  {
    id: "dataType",
    text: "Select Data Type."
  },
  {
    id: "leaveFrom",
    text: "Select leave From."
  },
  {
    id: "leaveTo",
    text: "Select Leave To."
  },
  {
    id: "numberOfDays",
    text: "Add Number of Leave Days."
  },
  {
    id: "leaveTypeId",
    text: "Select leave Type."
  },
  {
    id: "leaveReason",
    text: "Add Leave Reason."
  }
];

const actionButtons = [
  {
    bool: true,
    name: "hold",
    toolTipColor: "info",
    title: "Hold",
    className: "btn text-black btn-sm btn-warning-dev",
    icon: "mdi mdi-alert-outline",
    toolTipText: "Press to Hold Reimbursement"
  },
  {
    bool: true,
    name: "accept",
    toolTipColor: "info",
    title: "Accept",
    className: "btn text-black btn-sm btn-success",
    icon: "mdi mdi-check-all",
    toolTipText: "Press to Accept Reimbursement"
  },
  {
    bool: true,
    name: "reject",
    toolTipColor: "info",
    title: "Reject",
    className: "btn text-black btn-sm btn-danger",
    icon: "mdi mdi-close-circle-outline",
    toolTipText: "Press to Reject Reimbursement"
  }
];

export { tableHeaderData, actionButtons, toolTipData };
